import GiftWhiteLineIcon from './ic_gift_white_line.svg';
import LoudSpeakerCircleIcon from './ic_loud_speaker_circle.svg';

export { GiftWhiteLineIcon, LoudSpeakerCircleIcon };
